import React from "react";
import { GradeCoursesCard } from "./GradeCoursesCard";
import { GradeCoursesUIProvider } from "./GradeCoursesUIContext";

export function GradeCoursesPage({ history }) {
  const coursesUIEvents = {
    openCourseSubjectListPage: (courseId) => {
      history.push(`/ders-konulari/${courseId}`);
    },
    openNewGradeCoursePage: () => {
      history.push("/sinif-dersleri/ekle");
    },
    openEditGradeCoursePage: (id) => {
      history.push(`/sinif-dersleri/duzenle/${id}`);
    },
  };
  
  return (
    <GradeCoursesUIProvider coursesUIEvents={coursesUIEvents}>
      <GradeCoursesCard />
    </GradeCoursesUIProvider>
 );
}